import { render } from "./loginuser.vue?vue&type=template&id=39796152"
import script from "./loginuser.vue?vue&type=script&lang=js"
export * from "./loginuser.vue?vue&type=script&lang=js"

import "./loginuser.vue?vue&type=style&index=0&id=39796152&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__